import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiErrorDetail } from "@/hooks/useAuth";
import { TESTIDS } from "@/constants/testIds";

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from || "/play";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(identifier.trim(), password);
      navigate(from);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">Sign in</p>
        <h1 className="font-display text-4xl mt-1">Welcome back</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          New to Play Tsoro? <Link to="/register" className="text-primary hover:underline">Create an account</Link>
        </p>

        <Card className="mt-8 p-6">
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="identifier">Email or username</Label>
              <Input
                id="identifier"
                data-testid="login-identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-destructive">
                {error}
              </p>
            )}
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full rounded-full"
            >
              {busy ? "Signing in…" : "Sign in"}
            </Button>
            <p className="text-sm text-center">
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-muted-foreground hover:text-primary hover:underline">
                Forgot your password?
              </Link>
            </p>
          </form>
        </Card>
      </section>
    </Layout>
  );
}
